import { gql } from "@apollo/client";

export const SERVICE_LOGS = gql`
  query ServiceLogs($n: Int, $after: String, $hours: Int, $where: InputEvosLogEntryOperators){
    ServiceLogs(n: $n, after: $after, hours: $hours, where: $where) {
      edges {
        cursor
        node {
          cluster_name
          code
          container_name
          context
          description
          env
          hostname
          id
          location
          log_filter_tag
          namespace
          pod_name
          receive_timestamp
          resource_type
          retries
          severity
          source
          stacktrace
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
    }
  }       
`;
